import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_223: DocMigration = {
  maxSchemaVersion: "0.0.223",
  description: "Move schedule settings from plan setting object to schedule setting object",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "PLAN_SETTINGS") {
        const scheduleSettingId = uid();
        json.settings[scheduleSettingId] = {
          id: scheduleSettingId,
          name: "Schedule Settings",
          type: "SCHEDULE_SETTINGS",
          parentId: setting.parentId,
          sortIndex: setting.sortIndex + 1,
          entityType: "SETTINGS",
          scheduleSettingsTable: {
            DOOR: [
              {
                type: "DOOR",
                scheduleName: "DOORS",
                attributes: {
                  tag: {
                    definesEntity: true,
                    index: 0,
                    isHidden: false,
                    displayName: "Label",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  width: {
                    definesEntity: true,
                    unit: "INCHES",
                    index: 2,
                    isHidden: false,
                    displayName: "Width",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  height: {
                    definesEntity: true,
                    unit: "INCHES",
                    index: 3,
                    isHidden: false,
                    displayName: "Height",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  handing: {
                    definesEntity: true,
                    index: 4,
                    isHidden: false,
                    displayName: "Handing",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  area: {
                    definesEntity: false,
                    unit: "SQ IN",
                    index: 0,
                    isHidden: true,
                    displayName: "Area",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  class: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Class",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  panels: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Panels",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  swing: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Swing",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  details: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Details",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  floor: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Floor",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                },
                measures: {
                  count: {
                    isAggregated: true,
                    unit: "QUANTITY",
                    index: 1,
                    isHidden: false,
                    displayName: "Count",
                    aggregationMethod: "SUM",
                  },
                  width: {
                    isAggregated: false,
                    unit: "INCHES",
                    index: 0,
                    isHidden: true,
                    displayName: "Total Width",
                    aggregationMethod: "SUM",
                  },
                  height: {
                    isAggregated: false,
                    unit: "INCHES",
                    index: 0,
                    isHidden: true,
                    displayName: "Total Height",
                    aggregationMethod: "SUM",
                  },
                  area: {
                    isAggregated: false,
                    unit: "SQ IN",
                    index: 0,
                    isHidden: true,
                    displayName: "Total Area",
                    aggregationMethod: "SUM",
                  },
                },
                footnote: setting.doorScheduleFootnote ?? "",
                forceColumnNameUppercase: true,
                isActive: setting.includeDoorSchedule ?? true,
              },
            ],
            WINDOW: [
              {
                type: "WINDOW",
                scheduleName: "WINDOWS",
                attributes: {
                  tag: {
                    definesEntity: true,
                    index: 0,
                    isHidden: false,
                    displayName: "Label",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  width: {
                    definesEntity: true,
                    unit: "INCHES",
                    index: 2,
                    isHidden: false,
                    displayName: "Width",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  height: {
                    definesEntity: true,
                    unit: "INCHES",
                    index: 3,
                    isHidden: false,
                    displayName: "Height",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  perimeter: {
                    definesEntity: false,
                    unit: "INCHES",
                    index: 0,
                    isHidden: true,
                    displayName: "Perimeter",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  operationType: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Operation Type",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  verticalDivisions: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Vertical Divisions",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  panelType: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Panel Type",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  glazingType: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Glazing Type",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  glazingColor: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Glazing Color",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  grids: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Grids",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  floor: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Floor",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                },
                measures: {
                  count: {
                    isAggregated: true,
                    unit: "QUANTITY",
                    index: 1,
                    isHidden: false,
                    displayName: "Count",
                    aggregationMethod: "SUM",
                  },
                  width: {
                    isAggregated: false,
                    unit: "INCHES",
                    index: 0,
                    isHidden: true,
                    displayName: "Total Width",
                    aggregationMethod: "SUM",
                  },
                  height: {
                    isAggregated: false,
                    unit: "INCHES",
                    index: 0,
                    isHidden: true,
                    displayName: "Total Height",
                    aggregationMethod: "SUM",
                  },
                  perimeter: {
                    isAggregated: false,
                    unit: "INCHES",
                    index: 0,
                    isHidden: true,
                    displayName: "Total Perimeter",
                    aggregationMethod: "SUM",
                  },
                },
                footnote: setting.windowScheduleFootnote ?? "",
                forceColumnNameUppercase: true,
                isActive: setting.includeWindowSchedule ?? true,
              },
            ],
            FLOORING: [
              {
                type: "FLOORING",
                scheduleName: "ROOMS NET AREA",
                attributes: {
                  roomName: {
                    definesEntity: true,
                    index: 0,
                    isHidden: false,
                    displayName: "Name",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  material: {
                    definesEntity: true,
                    index: 2,
                    isHidden: false,
                    displayName: "Floor Material",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  level: {
                    definesEntity: true,
                    index: 3,
                    isHidden: false,
                    displayName: "Level",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                  materialHash: {
                    definesEntity: false,
                    index: 0,
                    isHidden: true,
                    displayName: "Material Hash",
                    includeFilter: "",
                    excludeFilter: "",
                  },
                },
                measures: {
                  area: {
                    isAggregated: true,
                    unit: "SQ FT",
                    index: 1,
                    isHidden: false,
                    displayName: "Area",
                    aggregationMethod: "SUM",
                  },
                  count: {
                    isAggregated: false,
                    unit: "QUANTITY",
                    index: 0,
                    isHidden: true,
                    displayName: "Count",
                    aggregationMethod: "SUM",
                  },
                },
                footnote: "",
                forceColumnNameUppercase: true,
                isActive: setting.includeRoomSchedule ?? true,
              },
            ],
          },
        };
      }
    }
    return json;
  },
};

export default migration_0_0_223;
